import { Route } from "@angular/router";

export const VolunteersPaths = {
  Candidates: "kandidaten",
  CandidateEdit: (candidateId: string | number) => `kandidaten/bewerken/${candidateId}`,
  CandidateAdd: "kandidaten/toevoegen",
  Overview: "overzicht",
  Import: "importeren",
  Register: "register",
  Groups: "groepen",
  GroupEdit: (groupId: number | string) => `groepen/bewerken/${groupId}`,
  GroupAdd: "groepen/toevoegen",
  Functions: "functies",
  PolicyAreas: "beleidsdomeinen",
  Start: "start",
  Statistics: "statistieken",
  AgreementNotes: "afsprakennotas",
  VolunteerEdit: (volunteerId: string | number) => `bewerken/${volunteerId}`,
  VolunteerAdd: "toevoegen",
  VolunteerMerge: (oldVolunteerId: number | string, newVolunteerId: number | string) =>
    `${oldVolunteerId}/update/${newVolunteerId}`,
};

export default [
  {
    path: VolunteersPaths.Start,
    loadComponent: () =>
      import("./pages/volunteers-start/volunteers-start.component").then(
        (c) => c.VolunteersStartComponent
      ),
    data: {
      breadcrumb: "Snel starten",
      title: "Vrijwilligers",
    },
  },
  {
    path: VolunteersPaths.Candidates,
    loadComponent: () =>
      import("./pages/volunteers-candidates-list/volunteers-candidates-list.component").then(
        (c) => c.VolunteersCandidatesListComponent
      ),
    data: {
      breadcrumb: "Kandidaat-vrijwilligers",
      title: "Kandidaat-vrijwilligers",
      subscriptionTypes: [1, 4, 5],
    },
  },
  {
    path: "candidates",
    redirectTo: VolunteersPaths.Candidates,
    pathMatch: "prefix",
  },
  {
    path: VolunteersPaths.CandidateEdit(":id"),
    loadComponent: () =>
      import("./pages/volunteer-candidate-edit/volunteer-candidate-edit.component").then(
        (c) => c.VolunteerCandidateEditComponent
      ),
    data: {
      breadcrumb: "Kandidaat-vrijwilliger bewerken",
      title: "Kandidaat-vrijwilliger bewerken",
      subscriptionTypes: [1, 4, 5],
    },
  },
  {
    path: VolunteersPaths.CandidateAdd,
    loadComponent: () =>
      import("./pages/volunteer-candidate-edit/volunteer-candidate-edit.component").then(
        (c) => c.VolunteerCandidateEditComponent
      ),
    data: {
      breadcrumb: "Kandidaat-vrijwilliger toevoegen",
      title: "Kandidaat-vrijwilliger toevoegen",
      subscriptionTypes: [1],
    },
  },
  {
    path: VolunteersPaths.Overview,
    loadComponent: () =>
      import("./pages/volunteer-list/volunteer-list.component").then(
        (c) => c.VolunteerListComponent
      ),
    data: {
      breadcrumb: "Overzicht",
      title: "Vrijwilligers",
      subscriptionTypes: [1],
    },
  },
  {
    path: VolunteersPaths.Import,
    loadComponent: () =>
      import("../person/pages/person-import/person-import.component").then(
        (c) => c.PersonImportComponent
      ),
    data: {
      breadcrumb: "Vrijwilligers importeren",
      title: "Vrijwilligers importeren",
      subscriptionTypes: [1],
    },
  },
  {
    path: VolunteersPaths.Register,
    loadComponent: () =>
      import("./pages/volunteers-register/volunteers-register.component").then(
        (c) => c.VolunteersRegisterComponent
      ),
    data: {
      breadcrumb: "Vrijwilligersregister",
      title: "Vrijwilligersregister",
      subscriptionTypes: [1],
    },
  },
  {
    path: VolunteersPaths.Groups,
    loadComponent: () =>
      import("./pages/workgroup-list/workgroup-list.component").then(
        (c) => c.WorkgroupListComponent
      ),
    data: {
      breadcrumb: "Vrijwilligersgroepen",
      title: "Vrijwilligersgroepen",
      subscriptionTypes: [1],
    },
  },
  {
    path: VolunteersPaths.GroupEdit(":id"),
    loadComponent: () =>
      import("./pages/workgroup-edit/workgroup-edit.component").then(
        (c) => c.WorkgroupEditComponent
      ),
    data: {
      breadcrumb: "Vrijwilligersgroep bewerken",
      title: "Vrijwilligersgroep bewerken",
      subscriptionTypes: [1],
    },
  },
  {
    path: VolunteersPaths.GroupAdd,
    loadComponent: () =>
      import("./pages/workgroup-edit/workgroup-edit.component").then(
        (c) => c.WorkgroupEditComponent
      ),
    data: {
      breadcrumb: "Vrijwilligersgroep toevoegen",
      title: "Vrijwilligersgroep toevoegen",
      subscriptionTypes: [1],
    },
  },
  {
    path: VolunteersPaths.Functions,
    loadComponent: () =>
      import("./pages/function-list/function-list.component").then((c) => c.FunctionListComponent),
    data: {
      breadcrumb: "Functies",
      title: "Functies",
      subscriptionTypes: [1],
    },
  },
  {
    path: VolunteersPaths.PolicyAreas,
    loadComponent: () =>
      import("./pages/policy-area-list/policy-area-list.component").then(
        (c) => c.PolicyAreaListComponent
      ),
    data: {
      breadcrumb: "Beleidsdomeinen",
      title: "Beleidsdomeinen",
      subscriptionTypes: [1],
    },
  },
  {
    path: VolunteersPaths.Statistics,
    loadComponent: () =>
      import("./pages/volunteer-stats/volunteer-stats.component").then(
        (c) => c.VolunteerStatsComponent
      ),
    data: {
      breacrumb: "Statistiek",
      title: "Statistieken",
      subscriptionTypes: [1],
    },
  },
  {
    path: VolunteersPaths.AgreementNotes,
    loadComponent: () =>
      import("../documents/pages/document-template-list/document-template-list.component").then(
        (c) => c.DocumentTemplateListComponent
      ),
    data: {
      breadcrumb: "Sjablonen voor afsprakennota's",
      title: "Sjablonen voor afsprakennota's",
      subscriptionTypes: [1],
    },
  },
  {
    path: VolunteersPaths.VolunteerMerge(":id", ":newId"),
    loadComponent: () =>
      import("../members/pages/member-update/member-update.component").then(
        (c) => c.MemberUpdateComponent
      ),
    data: {
      breadcrumb: "Persoonsgegevens nakijken",
      title: "Persoonsgegevens nakijken",
      subscriptionTypes: [1],
    },
  },
  {
    path: VolunteersPaths.VolunteerEdit("/:id"),
    loadComponent: () =>
      import("../person/pages/person-edit/person-edit.component").then(
        (c) => c.PersonEditComponent
      ),
    data: {
      breadcrumb: "Vrijwilliger bewerken",
      title: "Vrijwilliger bewerken",
      volunteer: true,
      subscriptionTypes: [1],
    },
  },
  {
    path: VolunteersPaths.VolunteerAdd,
    loadComponent: () =>
      import("./pages/volunteer-add/volunteer-add.component").then((c) => c.VolunteerAddComponent),
    data: {
      breadcrumb: "Vrijwilliger toevoegen",
      title: "Nieuwe vrijwilliger toevoegen",
      volunteer: true,
      subscriptionTypes: [1],
    },
  },
] satisfies Route[];
